let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fUQfj")).then(() => parcelRequire('5ZhIZ'));